// extracted by mini-css-extract-plugin
export default {"menu":"EndCall_menu__nyoTm","deviceButton":"EndCall_deviceButton__MsIKx","shareIcon":"EndCall_shareIcon__uvfRN","dialog":"EndCall_dialog__TwBCb"};